<template>
  <div class="chart-container">
    <h2 class="chart-question" v-if="opts.options.showQuestion">{{chartData.label}}</h2>
    <ul class="chart-list">
      <li v-for="(answer, index) in chartData.answersData" v-bind:key="answer.answerId">
        <div class="chart-horizontal" v-bind:class="{ 'chart-vote': answer.answered }">
          <div class="vote-icon" v-if="answer.answered"><span>{{translations.yourVote}}</span></div>
          <div class="chart-rank">
            <h3>#{{answer.index}}</h3>
          </div>
          <div class="chart-picture-container" v-if="opts.options.showIllustrations &&answer.picture">
            <img :src="`${answer.picture}`" :alt="`${answer.pictureAlt || ''}`" class="chart-picture" />
          </div>
          <div class="chart-middle">
            <div class="chart-label">
              <span v-html="answer.label"></span>
            </div>
            <div class="chart-bar-value">
              <div class="chart-bar-container">
                <div class="chart-bar" v-bind:style="`width:${chartValues.percents[index]}%;background: #${answer.color} !important;`"></div>
              </div>
              <div class="chart-value" v-if="opts.options.showVotesByAnswer">
                <div class="chart-value-container">
                  <div class="chart-percentage">
                    <span>{{chartValues.percents[index]}}%</span>
                  </div>
                  <div class="chart-number">
                    <span>{{answer.result}}</span>
                    <span v-if="answer.result > 1">{{translations.votes}}</span>
                    <span v-else-if="answer.result <= 1">{{translations.vote}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { calculateTotalPercent } from '../../helpers/percentagesTo100'
import { calculatePercentage } from '../../helpers/calculatePercentage'

export default {
  name: 'Hbarcustom',
  props: ['chartData', 'translations', 'opts'],
  data () {
    return {
      chartValues: {
        totalPercent: 0,
        percents: []
      },
      chartTotal: this.total
    }
  },
  methods: {
    resizeAndSetDivHeight: function () {
      const divs = document.getElementsByClassName('chart-picture-container')
      if (!divs[0]) return
      var w = divs[0].offsetWidth

      for (var i = 0; i < divs.length; i++) {
        if (w !== 0) {
          divs[i].style.height = w + 'px'
        }
      }
    }
  },
  mounted () {
    let falsedPercents = []
    for (let i = 0; i < this.chartData.answersData.length; i++) {
      if (this.chartData.totalVotes !== 0) {
        if (this.chartData.answersData[i].result !== 0) {
          falsedPercents.push(calculatePercentage(this.chartData.answersData[i].result, this.chartData.totalVotes, 1))
        } else {
          falsedPercents.push(0)
        }
      }
    }

    if (this.chartData.total !== 0) {
      this.chartValues.percents = calculateTotalPercent(falsedPercents, 100)
    } else {
      this.chartValues.percents = falsedPercents
    }

    this.chartValues.totalPercent = this.chartValues.percents.reduce((acc, x) => { acc += x; return acc }, 0)

    var that = this
    that.resizeAndSetDivHeight()
    window.onresize = function (e) { that.resizeAndSetDivHeight() }
  }
}
</script>

<style scoped src="../../assets/css/chart-horizontal.css">
</style>



// WEBPACK FOOTER //
// src/components/charts/HBarCustom.vue